import React, { useEffect, useState } from 'react';

import ProductBanner from '../components/ProductBanner';
import ProductGrid from '../components/ProductDisplay';

import ProductShowcase from '../components/ProductShowcase';
import ExpertReviews from '../components/ProductExpert';
const ProductPage = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 600);

  useEffect(() => {
    // Update isMobile state on window resize
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 600);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);


  const styles = {
    hero: {
      marginTop: isMobile ? '30px' : '70px',
      marginBottom: isMobile ? '20px' : '30px',
    },
    hero2: {
      marginTop: isMobile ? '45px' : '60px',
      // marginBottom: isMobile ? '20px' : '20px',
    },
    hero3: {
      marginTop: isMobile ? '25px' : '20px',
      // marginBottom: isMobile ? '20px' : '20px',
    },
  };
  return (
    <div>
   
      <ProductBanner />
      <div style={styles.hero}>
      <ProductShowcase />
      </div>
      {/* <ProductShowcase /> */}
  
      <div id="all-routers-section" style={styles.hero2}>
      <ProductGrid />
</div>
<div style={{ marginTop: '30px' }}>
<ExpertReviews />
      </div>

 
{/* <NotFound404 /> */}
    </div>
  )
}

export default ProductPage
